/* eslint-disable consistent-return */
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { get } from 'lodash';

export default () => (store) => {
  if (process.env.VUE_APP_S3D_STAGE === undefined
        || process.env.VUE_APP_VERSION === undefined) {
    console.warn('Datadog not enabled');
    return;
  }

  let replaySampleRate = 20;
  if (process.env.VUE_DD_REPLAY_SAMPLE !== undefined) {
    replaySampleRate = parseInt(process.env.VUE_DD_REPLAY_SAMPLE, 10) || 20;
  }

  const commonDatadogConfig = {
    clientToken: 'pub7f596bf23d259647657ba3d60116277c',
    site: 'datadoghq.eu',
    service: 'recruitment',
    env: process.env.VUE_APP_S3D_STAGE,
    version: process.env.VUE_APP_VERSION,
    sessionSampleRate: 100,
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
  };

  datadogLogs.init({
    ...commonDatadogConfig,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    forwardReports: 'all',
    telemetrySampleRate: 0,
  });

  datadogRum.init({
    ...commonDatadogConfig,
    applicationId: '39cae8e1-0628-41d9-9fc2-9784ad760dd6',
    sessionReplaySampleRate: replaySampleRate,
    traceSampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
    allowedTracingUrls: [
      /https:\/\/.*\.coactivecare\.co\.uk/,
    ],
  });

  // when user state changes update the datadog user properties
  return store.subscribe((mutation, state) => {
    if (mutation.type === 'auth/updateUser' || state.auth.authState === 'signedin') {
      datadogRum.setUserProperty('id', state.auth.user.id);
      if (state.auth.user.profile) {
        datadogRum.setUserProperty(
          'name',
          `${get(state.auth.user.profile, 'firstName').substring(0, 1).toUpperCase()}${get(state.auth.user.profile, 'lastName').substring(0, 1).toUpperCase()}`,
        );
      }
    }
    if (mutation.type === 'auth/changeAuthState' && state.auth.authState !== 'signedin') {
      datadogRum.stopSession();
      datadogRum.clearUser();
    }
  });
};
